import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import Tip from '../ui/BettingTooltip';
import { getBookmakerLabel } from '../../utils/bookmakers';

const COLORS = {
  draftkings: '#4f8ff7', fanduel: '#34d399', betmgm: '#f59e0b', betrivers: '#ef4444',
  bovada: '#8b5cf6', betonlineag: '#22d3ee', mybookieag: '#f472b6', betus: '#fb923c',
  lowvigag: '#a3e635', caesars: '#e879f9', williamhill_us: '#facc15',
  unibet_us: '#c084fc', superbook: '#2dd4bf', wynnbet: '#fda4af',
};
const FALLBACK = ['#60a5fa','#a78bfa','#fb7185','#4ade80','#fbbf24','#67e8f9','#f0abfc','#fdba74','#86efac','#fca5a1'];
let _fi = 0; const _dc = {};
function getColor(k) { if (COLORS[k]) return COLORS[k]; if (_dc[k]) return _dc[k]; _dc[k] = FALLBACK[_fi++ % FALLBACK.length]; return _dc[k]; }


export default function LineMovementChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-5 py-4">
        <SectionHeader><Tip term="linemovement">Line Movement</Tip></SectionHeader>
        <p className="text-[#8892a8] text-[11px] mt-2">No line movement data available.</p>
      </div>
    );
  }

  const bookmakers = [...new Set(data.map((d) => d.bookmaker))];
  const timestamps = [...new Set(data.map((d) => d.timestamp))].sort();
  const chartData = timestamps.map((ts) => {
    const row = { time: new Date(ts).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) };
    for (const bk of bookmakers) {
      const point = data.find((d) => d.timestamp === ts && d.bookmaker === bk);
      if (point) row[bk] = point.point;
    }
    return row;
  });

  return (
    <div className="rounded border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-5 py-4">
      <SectionHeader><Tip term="linemovement">Line Movement</Tip></SectionHeader>
      <div className="mt-3">
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="time" tick={{ fill: '#505a6e', fontSize: 10, fontFamily: 'var(--font-mono)' }} stroke="transparent" />
            <YAxis tick={{ fill: '#505a6e', fontSize: 10, fontFamily: 'var(--font-mono)' }} stroke="transparent" domain={['auto','auto']} reversed />
            <Tooltip contentStyle={{ backgroundColor: 'var(--tooltip-bg)', border: '1px solid var(--tooltip-border)', borderRadius: 4, color: 'var(--tooltip-text)', fontSize: 11, fontFamily: 'var(--font-mono)' }} />
            <Legend wrapperStyle={{ fontSize: 10, fontFamily: 'var(--font-sans)' }} />
            {bookmakers.map((bk) => {
              const color = getColor(bk);
              return <Line key={bk} type="stepAfter" dataKey={bk} name={getBookmakerLabel(bk)} stroke={color} strokeWidth={1.5} dot={{ r: 2, fill: color }} connectNulls />;
            })}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function SectionHeader({ children }) {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[3px] h-4 bg-[#005BB3] rounded-full" />
      <h3 className="text-[12px] uppercase tracking-[1px] font-medium text-[#005BB3] dark:text-[#3b82f6]" style={{ fontFamily: 'var(--font-sans)' }}>{children}</h3>
    </div>
  );
}
